import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from '@mui/material';
import React from 'react';
import { BasePage } from '../../components/templates/BasePage';
import { ProfileInformation } from './components/organisms/ProfileInformation';
var ProfilePage = function () {
    return (_jsx(BasePage, { selectedTab: false, children: _jsx(Grid, { container: true, direction: "column", alignItems: "center", spacing: 3, children: _jsx(Grid, { item: true, sx: { m: 3 }, children: _jsx(ProfileInformation, {}) }) }) }));
};
export default ProfilePage;
